import { ReactNode } from 'react';

interface BadgeNBProps {
  variant?: 'success' | 'warning' | 'error' | 'info';
  children: ReactNode;
  className?: string;
  size?: 'sm' | 'md';
}

const variantStyles = {
  success: 'bg-green text-nb-black border-3 border-nb-black',
  warning: 'bg-yellow text-nb-black border-3 border-nb-black',
  error: 'bg-nb-red text-white border-3 border-nb-black',
  info: 'bg-nb-black text-white border-3 border-nb-black',
};

const sizeStyles = {
  sm: 'text-xs px-1.5 py-0.5',
  md: 'text-sm px-2 py-0.5',
};

export default function BadgeNB({
  variant = 'info',
  children,
  className = '',
  size = 'md',
}: BadgeNBProps) {
  const variantClass = variantStyles[variant] || variantStyles.info;
  const sizeClass = sizeStyles[size] || sizeStyles.md;

  return (
    <span
      className={`
        inline-block
        font-nb font-bold
        ${sizeClass}
        ${variantClass}
        ${className}
      `.replace(/\s+/g, ' ').trim()}
    >
      {children}
    </span>
  );
}
